<script setup lang="ts">
const { getXLink } = useDownload()
const link = getXLink()

const { isWindows } = useDevice()
const { queryData } = storeToRefs(useQueryStore())

const showChevron = ref(false)

onMounted(() => {
  setTimeout(() => {
    showChevron.value = true
  }, 2000)
})
</script>

<template>
  <!-- 首屏banner -->
  <section class="relative h-100vh">
    <picture>
      <source class="absolute size-full object-cover object-c" srcset="/home/home-bg-mob.webp" media="(max-width: 768px)">
      <source class="absolute size-full object-cover object-c" srcset="/home/home-bg.webp">
      <img class="absolute aspect-ratio-16/9 size-full object-cover object-c" src="/home/home-bg.webp" fetchpriority="high" :alt="$t('home_page.first_desc').replace('<br>', '')">
    </picture>

    <div class="absolute z-2 h-22.22% w-full" inset="is-0 bs-0" bg-gradient="to-b from-[--bg-color] to-transparent" />
    <div class="absolute z-2 h-29.62% w-full" inset="is-0 be-0" bg-gradient="to-t from-[--bg-color] to-transparent" />

    <div class="absolute-center z-3 lt-md:w-full">
      <div class="headlogo flex flex-col items-center">
        <img w="70vw lg:auto" class="aspect-ratio-320/33" fetchpriority="high" width="640" src="/home/logo-x.webp" alt="">
        <h1 class="c-#fff c-op-1">
          LDPlayer X
        </h1>

        <p class="px-16px text-center c-#fff font-700" lh="24px md:36px" text="16px md:32px" m="t-20px md:t-40px b-34px md:b-60px" v-html="$t('home_page.first_desc')" />

        <ClientOnly>
          <a
            v-if="isWindows"
            v-track="{ id: 'web-index-first-download', click: { value: { openid: queryData.openid } } }"
            :href="link" class="ld-button rd-8px text-24px font-700 transition-all-300 lt-md:hidden ld-button-yellow"
            p="x-40px y-20px" bg="cover no-repeat" :style="{ 'background-image': `url(${getPublicImg('home/btn-bg-action.apng')})` }"
          >
            {{ $t('layout.download_ld_x') }}
          </a>

          <div
            v-else class="relative max-w-260px w-68vw of-hidden rd-8px lh-18px"
            c="#fff op-90" bg="#000 op-20" text="12px center" b="~ solid #fff op-20"
          >
            <p class="relative z-2 from-#0d0b24 to-purple-45 from-op-70 to-op-90 bg-gradient-to-b px-20px py-8px">
              {{ $t('game.support_device_text') }}
            </p>
          </div>

          <template #fallback>
            <a
              :href="link" class="ld-button rd-8px text-24px font-700 transition-all-300 lt-md:hidden ld-button-yellow"
              p="x-40px y-20px" bg="cover no-repeat" :style="{ 'background-image': `url(${getPublicImg('home/btn-bg-action.apng')})` }"
            >
              {{ $t('layout.download_ld_x') }}
            </a>
          </template>
        </ClientOnly>
      </div>
    </div>

    <img class="absolute bottom-6vh left-50% z-3 h-auto w-18px translate-x--50% transition-all-300 md:w-24px" :class="showChevron ? 'op-100' : 'op-0'" src="/home/chevron-down-more.apng" alt="">
  </section>
</template>

<style lang="scss" scoped>
@keyframes fade-up-logo {
  from {
    opacity: 0.1;
    transform: translate3d(0, 60px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
.headlogo {
  animation-name: fade-up-logo;
  animation-duration: 1000ms;
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  animation-iteration-count: 1;
}
</style>
